import {Component, computed, input} from '@angular/core';
import {WineProduct} from '@core/interfaces/generated/graphql';

@Component({
  selector: 'app-product-discount-label',
  templateUrl: './product-discount-label.component.html',
  styleUrls: ['./product-discount-label.component.scss'],
  imports: [],
  host: {
    '[style.background-color]': 'badgeBackgroundColor()',
    '[style.color]': 'badgeTextColor()',
  }
})
export class ProductDiscountLabelComponent {

  product = input.required<WineProduct | undefined>();

  constructor(
  ) {
  }

  // Hide regular badge if custom badge HTML exists (custom badge always takes priority)
  shouldShow = computed(() => {
    const hasCustomBadge = !!this.product()?.customBadgeHTML;
    return !hasCustomBadge && !!this.badgeType();
  });

  badgeType = computed(() => this.product()?.productImageBadge?.type);

  isCampaignDiscount = computed(() => this.badgeType() === 'campaign_discount');

  badgeBackgroundColor = computed(() => {
    if (this.isCampaignDiscount() && this.product()?.productImageBadge?.badgeColor) {
      return this.product()?.productImageBadge?.badgeColor;
    }
    return null; // Will use default CSS
  });

  badgeTextColor = computed(() => {
    if (this.isCampaignDiscount() && this.product()?.productImageBadge?.textColor) {
      return this.product()?.productImageBadge?.textColor;
    }
    return null; // Will use default CSS
  });
}
